import { render } from "./ItemDetailPanel.vue?vue&type=template&id=72301b95&scoped=true"
import script from "./ItemDetailPanel.vue?vue&type=script&lang=js"
export * from "./ItemDetailPanel.vue?vue&type=script&lang=js"

import "./ItemDetailPanel.vue?vue&type=style&index=0&id=72301b95&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72301b95"]])

export default __exports__